import { render, staticRenderFns } from "./emailService.vue?vue&type=template&id=72ad00c2&scoped=true"
import script from "./emailService.vue?vue&type=script&lang=js"
export * from "./emailService.vue?vue&type=script&lang=js"
import style0 from "./emailService.vue?vue&type=style&index=0&id=72ad00c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72ad00c2",
  null
  
)

export default component.exports